// export const baseurl = "http://localhost:8080/brick";
// export const pythonurl = "http://localhost:5000";

// export const baseurl = 'http://192.168.0.20:8080/brick'
// export const pythonurl = 'http://192.168.1.3:5000/brick'

// export const baseurl = 'http://192.168.0.2:8080/brick'
// export const pythonurl = 'http://192.168.0.2:5000/brick'

//brick 
// export const baseurl = 'https://www.brick-erp.com/brick'
// export const pythonurl = 'https://brickpy.brick-erp.com'

// Test
export const baseurl = 'https://www.brick-erp.com/brick-test'
export const pythonurl = 'https://brickpy.brick-erp.com'
